export default __webpack_public_path__ + "static/media/preview-video-1.d7e12165.png";